import { Outlet } from "react-router-dom";
import { PrivateRoute } from ".";
import Header from "../components/Header";
import InstructorHome from "../pages/instructor/InstructorHome";

const instructorRoutes = [
  {
    path: "instructor",
    element: (
      <PrivateRoute role="instructor">
        <Header role="instructor" />
        <div className="content">
          <Outlet />
        </div>
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: <InstructorHome />,
      },
    ],
  },
];

export default instructorRoutes;
